export default __webpack_public_path__ + "static/media/i138sk.db7f4ac7.webp";